<template>
	<v-dialog v-model="dialog" persistent max-width="800" scrollable content-class="rounded-xl">
		<v-card>
			<v-card-title class="justify-space-between">
				<div class="font-size-13 font-size-xs-11 secondary--text">Product Details</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="pt-2">
				<v-row v-if="Object.keys(productDetail).length > 0">
					<v-col cols="12" sm="4">
						<v-img eager width="100%" height="280" class="mx-auto rounded-xl" :src="productDetail.product_image ? productDetail.product_image : require('/public/assets/image/user-pict.jpg')"></v-img>
					</v-col>
					<v-col cols="12" sm="8">
						<div class="font-size-11 secondary--text">{{ productDetail.product_name }}</div>
						<div class="d-flex">
							<div class="font-size-12 primary--text">{{ productDetail.product_member_price | toCurrencyFormat }}</div>
						</div>
						<div class="pt-5 cl-grey font-size-11 font-weight-bold">Description</div>
						<div class="pt-1 font-size-11 cl-grey" v-html="productDetail.product_description ? productDetail.product_description : '-'"></div>
					</v-col>
				</v-row>
				<v-row v-else>
					<v-col cols="12">
						<v-card loading="primary" class="elevation-0">
							<div class="d-flex flex-column align-center pa-5 my-4">
								<v-img eager class="mx-auto" width="50" height="50" :src="require('/public/assets/icon/loading.svg')"></v-img>
								<div class="pt-3 text-center primary--text">Loading information...</div>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
	components: {
	},
	data () {
		return {
			dialog: false,
		}
	},
	props: {
	},
	computed: {
		...mapState('produk', ['productDetail']),
	},
	methods: {
		...mapMutations('produk', ['emptyProductDetail']),

		modalHide() {
			this.dialog = false
			this.emptyProductDetail()
		},
		modalShow() {
			this.dialog = true
		},
	}
};
</script>